import Vue from 'vue'
import router from './router'
import store from './store'

import App from './App.vue'
import Amplify from 'aws-amplify'
//import Amplify, * as AmplifyModules from 'aws-amplify'
//import '@aws-amplify/ui-vue'
import aws_exports from './aws-exports'

import './registerServiceWorker'
import vuetify from './plugins/vuetify';
import gv from '@/mixins/global.js'
import moment from 'moment'
import ToggleButton from 'vue-js-toggle-button'
import BreadCrumb from '@/components/BreadCrumb'
import Loading from '@/components/Loading'
import VueExcelEditor from 'vue-excel-editor'
import VueExcelXlsx from 'vue-excel-xlsx'
import axios from 'axios'
import {VueMasonryPlugin} from 'vue-masonry'

axios.defaults.headers.get['Content-Type'] = 'text/html'

Amplify.configure(aws_exports)

Vue.config.productionTip = false
Vue.prototype.$http = axios

moment.locale('ja', {
  week: { dow: 0 }
})

Vue.mixin(gv)
Vue.use(ToggleButton)
Vue.use(VueExcelEditor)
Vue.use(VueExcelXlsx)
Vue.use(VueMasonryPlugin)
Vue.component('BreadCrumb', BreadCrumb)
Vue.component('Loading', Loading)

new Vue({
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount('#app')
